
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Btn from "../common/Btn";
import { MERCH } from "../../data";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { IProfileWebsite } from "../../../../../services";
import { activeMedia, pagePath } from "../../helpers";

export interface StoreSplitProps {
    basePath: string;
    website: IProfileWebsite;
}

function StoreSplit({ website, basePath }: StoreSplitProps) {

    const labels = i18nManager.Labels;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const image = activeMedia(website, "HALF_BODY") ?? activeMedia(website, "BANNER");

    return (<section className={styles["store-split"]}>
        {image && (<div className={styles["store-split-img"]}>
            <img src={image} alt={website.display_name} loading="lazy" />
        </div>)}
        <div className={styles["store-split-panel"]} style={image ? undefined : { gridColumn: "1 / -1" }}>
            <h2 className={styles["title"]}>{labels.official_store}</h2>
            <p className={styles["sub"]}>{labels.store.desc}</p>
            <div className={styles["store-thumbs"]}>
                {MERCH.slice(0, 4).map((item) => (<img key={item.id} src={item.img} alt={item.name} loading="lazy" />))}
            </div>
            <Btn variant="dark" to={{ pathname: pagePath(basePath, "MERCH"), search: searchParams.toString() }}>{labels.home.shop_now}</Btn>
        </div>
    </section>);
}

export default StoreSplit;
